import React, { useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Link } from 'react-router-dom';
import { FaUserTie } from "react-icons/fa";
import { BiDonateBlood } from "react-icons/bi";
import { FaUsersCog } from "react-icons/fa";
import { MdHealthAndSafety } from "react-icons/md";
import { FaGraduationCap } from "react-icons/fa";
import { FaEnvira } from "react-icons/fa";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { AiOutlineUserSwitch } from "react-icons/ai";
import { BsPiggyBank } from "react-icons/bs";
import Api from '../function/axiosInterceptor';
let Home = () => {
    const [index, setIndex] = useState(0);
    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };
    const [home, setHome] = useState({ counter: [{ sno: '0', title: '', count: '' }], what_we_do: [{ sno: '1', titel: '', content: '' }], our_work: [{ sno: '1', titel: '', content: '' }] });
    useEffect(() => {
        Api.get('/home').then((response) => {
            if (response.status === 'success') {
                setHome(response.data);
            } else {
                console.log('Api Error');
            }
        }).catch((error) => {
            console.error('Error 404');
        })
    }, []);
    return (<>
        <section>

           <Carousel activeIndex={index} onSelect={handleSelect} interval={3000}>
    {
        home.banner &&
        [...home.banner] // copy to avoid mutation
            .sort((a, b) => new Date(b.last_modify) - new Date(a.last_modify))
            .map((bnr) => {
                return (
                    <Carousel.Item key={bnr.sno}>
                        <img
                            className="d-block w-100"
                            src={process.env.REACT_APP_IMG_BASE_URL + "/img/" + bnr.image}
                            alt="slide"
                        />
                        <Carousel.Caption>
                            <h3>
                                <div dangerouslySetInnerHTML={{ __html: bnr.Heading }}></div>
                            </h3>
                            <p>
                                <div dangerouslySetInnerHTML={{ __html: bnr.Content }}></div>
                            </p>
                        </Carousel.Caption>
                    </Carousel.Item>
                )
            })
    }
</Carousel>

            {/* <Carousel activeIndex={index} onSelect={handleSelect} interval={'3000'}>
                {
                    home.banner && home.banner.map((bnr) => {
                        return (
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={process.env.REACT_APP_IMG_BASE_URL + "/img/" + bnr.image}
                                    alt="First slide"
                                />
                                <Carousel.Caption>
                                    <h3><div className="Container" dangerouslySetInnerHTML={{ __html: bnr.Heading }}></div></h3>
                                    <p><div className="Container" dangerouslySetInnerHTML={{ __html: bnr.Content }}></div></p>
                                </Carousel.Caption>
                            </Carousel.Item>
                        )
                    })
                }
            </Carousel> */}

           
            <div className="header-bottom-area m-top bg-image padding-bottom-120 padding-top-120">

                <div class="container">
   <div class="row">
      <div class="col-xl-6">
         <div class="about-One__left  ">
            <div class="about-One__img-box">
               <div class="about-One__img">
                  <img src="/main/files/static/about1s.jpg" alt=""/>
               </div>
               <div class="about-One__img-2">
                  <img src="/main/files/static/about2.jpg" alt=""/>
               </div>
               <div class="about-One__provide-box" >
                  <div class="about-One__provide-icon">
                     <span class="icon-pet-care"></span>
                  </div>
                  <div class="about-One__provide-content">
                     <div class="about-One__provide-count count-box counted">
                        <h3 class="count-text" data-stop="250" data-speed="1500">850</h3>
                        <span>+</span>
                     </div>
                     <p class="about-One__provide-count-text mb-0">We help over people</p>
                  </div>
               </div>
               <div class="about-One__shape-1"></div>
            </div>
         </div>
      </div>
      <div class="col-xl-6">
         <div class="about-One__right" >
            <div class="section-title text-left sec-title-animation animation-style2">
               
              
               <h2 class="section-title__title title-animation">
                Serving Humanity with Compassion, <br></br> Commitment & Care
               </h2>

               <p>MNB Foundation is a charitable and welfare trust dedicated to creating meaningful, long-term impact in the lives of underprivileged individuals and communities. Guided by the values of compassion, transparency, and social responsibility, we work tirelessly to support education, healthcare, social welfare, environmental protection, and humanitarian relief.
</p>
<p>We believe that true development begins when people are empowered with opportunities, dignity, and hope. Through our initiatives and partnerships, we strive to build a more inclusive, caring, and sustainable society.</p>
            </div>
         
            <ul class="nav nav-pills bg-nav-pills nav-justified mb-3">
    <li class="nav-item">
        <a href="#home1" data-bs-toggle="tab" aria-expanded="true" class="nav-link rounded-0 active">
            <i class="mdi mdi-home-variant d-md-none d-block"></i>
            <span class="d-none d-md-block">Our Vision</span>
        </a>
    </li>
    <li class="nav-item">
        <a href="#profile1" data-bs-toggle="tab" aria-expanded="false" class="nav-link rounded-0 ">
            <i class="mdi mdi-account-circle d-md-none d-block"></i>
            <span class="d-none d-md-block">Our Mission</span>
        </a>
    </li>
    <li class="nav-item">
        <a href="#settings1" data-bs-toggle="tab" aria-expanded="false" class="nav-link rounded-0">
            <i class="mdi mdi-settings-outline d-md-none d-block"></i>
            <span class="d-none d-md-block">Our Core Values</span>
        </a>
    </li>
</ul>

<div class="tab-content">
    <div class="tab-pane section-title show active" id="home1">
        
     <p>To create a society where every individual has access to basic necessities, equal opportunities, quality education, proper healthcare, and a dignified life, regardless of their social or economic background.</p>
<p>We envision a future where communities are self-reliant, compassionate, and united, working together for the welfare of all.</p>
    </div>
    <div class="tab-pane section-title " id="profile1">
        <p>To serve humanity by addressing social challenges through education, healthcare, welfare support, and community development initiatives that uplift underprivileged individuals and families.</p>
        <p>We strive to create sustainable impact by empowering communities, encouraging participation, and delivering transparent, ethical, and compassionate social service for all.</p>
    </div>
    <div class="tab-pane section-title" id="settings1">
        <p>We are guided by compassion, integrity, transparency, and inclusivity in every action we take, ensuring respect, dignity, and fairness for all individuals and communities we serve.
</p>
<p>Our values inspire responsible service, long-term commitment, and collective growth toward building a just, caring, and socially responsible society.</p>
    </div>
</div>
         </div>
         <div class="about-One__btn-and-need-help">
                                <div class="about-One__btn-box">
                                    <Link to="/donate" class="about-One__btn thm-btn">Donate Now<span><i class="fas fa-angle-right"></i></span></Link>
                                </div>
                                <div class="about-One__need-help">
                                    <div class="icon">
                                        <span class="icon-phone-call"></span>
                                    </div>
                                    <div class="content">
                                        <p className='mb-0'>Need help?</p>
                                        <h4 className='mb-0'><a href="tel:918383959125">+91 8383959125</a></h4>
                                    </div>
                                </div>
                            </div>
      </div>
   </div>
</div>

             
            </div>

            <section class="found-one">
   <div class="found-one__bg">
      <div class="found-one__shape-1 float-bob-y">
         <img src="assets/images/shapes/found-one-shape-1.png" alt=""/>
      </div>
   </div>
   <div class="container">
      <div class="section-title text-center sec-title-animation animation-style1">
        
         <h2 class="section-title__title title-animation fw-semibold" >
           What We Do
         </h2>
         <p className=' mb-3' style={{maxWidth:"800px", margin: "0 auto"}}>We work to uplift underprivileged individuals and communities through education, healthcare, social welfare, women empowerment, environmental care, and humanitarian support, focusing on sustainable solutions that promote dignity, self-reliance, and long-term positive impact.</p>
      </div>
      <div class="row">
       
         <div class="col-xl-4 col-lg-4 wow fadeInLeft animated" data-wow-delay="100ms" >
            <div class="found-one__single">
               <div class="found-one__img-box">
                  <div class="found-one__img">
                     <img src="/main/files/static/edu.jpg" alt=""/>
                     <img src="/main/files/static/edu.jpg" alt=""/>
                  </div>
               </div>
               <div class="found-one__content">
                  <h4 class="found-one__title">Education & Skill Development</h4>
                  <p class="found-one__text">We support underprivileged children and youth through quality education, books, scholarships, digital literacy, and skill training, empowering them to gain knowledge, confidence, and opportunities for a self-reliant future.</p>
                 
                  <div class="found-one__btn-box">
                     <Link to="/donate" class="found-one__btn thm-btn">Donate Now<span><i class="fas fa-angle-right"></i></span></Link>
                  </div>
               </div>
            </div>
         </div>
        
         <div class="col-xl-4 col-lg-4 wow fadeInUp animated" data-wow-delay="200ms" >
            <div class="found-one__single">
               <div class="found-one__img-box">
                  <div class="found-one__img">
                     <img src="/main/files/static/health.jpg" alt=""/>
                     <img src="/main/files/static/health.jpg" alt=""/>
                  </div>
               </div>
               <div class="found-one__content">
                  <h4 class="found-one__title">Healthcare & Medical Support</h4>
                  <p class="found-one__text">We provide medical assistance, health camps, and awareness programs while supporting elderly, disabled, and critically ill individuals to improve access to healthcare and promote healthier, productive communities.</p>
                 
                  <div class="found-one__btn-box">
                     <Link to="/donate" class="found-one__btn thm-btn">Donate Now<span><i class="fas fa-angle-right"></i></span></Link>
                  </div>
               </div>
            </div>
         </div>
        
         <div class="col-xl-4 col-lg-4 wow fadeInRight animated" data-wow-delay="300ms">
            <div class="found-one__single">
               <div class="found-one__img-box">
                  <div class="found-one__img">
                     <img src="/main/files/static/social.jpg" alt=""/>
                     <img src="/main/files/static/social.jpg" alt=""/>
                  </div>
               </div>
               <div class="found-one__content">
                  <h4 class="found-one__title">Social Welfare</h4>
                  <p class="found-one__text">We assist disadvantaged individuals with food, clothing, and basic necessities, support orphans and senior citizens, and encourage livelihood programs that strengthen communities and promote sustainable development.</p>
               
                  <div class="found-one__btn-box">
                     <Link to="/donate" class="found-one__btn thm-btn">Donate Now<span><i class="fas fa-angle-right"></i></span></Link>
                  </div>
               </div>
            </div>
         </div>

          <div class="col-xl-4 col-lg-4 wow fadeInLeft animated" data-wow-delay="100ms" >
            <div class="found-one__single">
               <div class="found-one__img-box">
                  <div class="found-one__img">
                     <img src="/main/files/static/women.jpg" alt=""/>
                     <img src="/main/files/static/women.jpg" alt=""/>
                  </div>
               </div>
               <div class="found-one__content">
                  <h4 class="found-one__title">Women Empowerment</h4>
                  <p class="found-one__text">We promote women empowerment through education, skill training, health awareness, self-employment opportunities, and support for widows and single women, enabling independence and positive community impact.</p>
                 
                  <div class="found-one__btn-box">
                     <Link to="/donate" class="found-one__btn thm-btn">Donate Now<span><i class="fas fa-angle-right"></i></span></Link>
                  </div>
               </div>
            </div>
         </div>
        
         <div class="col-xl-4 col-lg-4 wow fadeInUp animated" data-wow-delay="200ms" >
            <div class="found-one__single">
               <div class="found-one__img-box">
                  <div class="found-one__img">
                     <img src="/main/files/static/cow.jpg" alt=""/>
                     <img src="/main/files/static/cow.jpg" alt=""/>
                  </div>
               </div>
               <div class="found-one__content">
                  <h4 class="found-one__title">Environmental & Animal Welfare</h4>
                  <p class="found-one__text">We encourage environmental conservation through tree plantation, cleanliness drives, awareness programs, and gau seva initiatives, promoting responsible resource use and harmony between humans, animals, and nature.</p>
                 
                  <div class="found-one__btn-box">
                     <Link to="/donate" class="found-one__btn thm-btn">Donate Now<span><i class="fas fa-angle-right"></i></span></Link>
                  </div>
               </div>
            </div>
         </div>
        
         <div class="col-xl-4 col-lg-4 wow fadeInRight animated" data-wow-delay="300ms">
            <div class="found-one__single">
               <div class="found-one__img-box">
                  <div class="found-one__img">
                     <img src="/main/files/static/flood.jpg" alt=""/>
                     <img src="/main/files/static/flood.jpg" alt=""/>
                  </div>
               </div>
               <div class="found-one__content">
                  <h4 class="found-one__title">Disaster Relief & Humanitarian Aid</h4>
                  <p class="found-one__text">We provide timely relief during disasters by distributing food, water, and essentials, supporting rehabilitation efforts, and assisting affected families with compassion, care, and hope.</p>
               
                  <div class="found-one__btn-box">
                     <Link to="/donate" class="found-one__btn thm-btn">Donate Now<span><i class="fas fa-angle-right"></i></span></Link>
                  </div>
               </div>
            </div>
         </div>
        
      </div>

     <div className="why">

       
         <div className="row">
         <div class="col-lg-12 wow fadeInLeft animated" data-wow-delay="100ms" >
            <div class="found-one__single pt-4">
                 <h3 className='mb-4'>Why Choose MNB Foundation</h3>
              <div className="row">
                 <div class="col-lg-3 wow fadeInUp animated" data-wow-delay="200ms" >
            <div class="why-item ">

               <div class="elementor-icon-box-icon">
				<span class="elementor-icon">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path></svg>	</span>
			</div>
               <div class="found-one__content">
                  <h4 class="found-one__title">Transparent & Ethical Operations</h4>
                  <p class="found-one__text">We ensure complete transparency and ethical practices in all activities, donations, and responsible fund utilization.</p>
                 
                
               </div>
            </div>
         </div>
        
         <div class="col-lg-3 wow fadeInRight animated" data-wow-delay="300ms">
            <div class="why-item">
                <div class="elementor-icon-box-icon">
				<span class="elementor-icon">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M5.23379 7.72989C6.65303 5.48625 9.15342 4 12.0002 4C14.847 4 17.3474 5.48625 18.7667 7.72989L20.4569 6.66071C18.6865 3.86199 15.5612 2 12.0002 2C8.43928 2 5.31393 3.86199 3.54356 6.66071L5.23379 7.72989ZM12.0002 20C9.15342 20 6.65303 18.5138 5.23379 16.2701L3.54356 17.3393C5.31393 20.138 8.43928 22 12.0002 22C15.5612 22 18.6865 20.138 20.4569 17.3393L18.7667 16.2701C17.3474 18.5138 14.847 20 12.0002 20ZM12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM12 15C10.8954 15 10 15.8954 10 17H8C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17H14C14 15.8954 13.1046 15 12 15ZM3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13C3.55228 13 4 12.5523 4 12C4 11.4477 3.55228 11 3 11ZM0 12C0 10.3431 1.34315 9 3 9C4.65685 9 6 10.3431 6 12C6 13.6569 4.65685 15 3 15C1.34315 15 0 13.6569 0 12ZM20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12ZM21 9C19.3431 9 18 10.3431 18 12C18 13.6569 19.3431 15 21 15C22.6569 15 24 13.6569 24 12C24 10.3431 22.6569 9 21 9Z"></path></svg></span>
			</div>
               <div class="found-one__content">
                  <h4 class="found-one__title">Community-Centered Approach</h4>
                  <p class="found-one__text">Our initiatives are thoughtfully designed based on genuine needs and real challenges faced by communities.</p>
               
                 
               </div>
            </div>
         </div>

         <div class=" col-lg-3 wow fadeInRight animated" data-wow-delay="300ms">
            <div class="why-item">
               <div class="elementor-icon-box-icon">
				<span class="elementor-icon">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="120" height="120" fill="currentColor"><path d="M12 11C14.7614 11 17 13.2386 17 16V22H15V16C15 14.4023 13.7511 13.0963 12.1763 13.0051L12 13C10.4023 13 9.09634 14.2489 9.00509 15.8237L9 16V22H7V16C7 13.2386 9.23858 11 12 11ZM5.5 14C5.77885 14 6.05009 14.0326 6.3101 14.0942C6.14202 14.594 6.03873 15.122 6.00896 15.6693L6 16L6.0007 16.0856C5.88757 16.0456 5.76821 16.0187 5.64446 16.0069L5.5 16C4.7203 16 4.07955 16.5949 4.00687 17.3555L4 17.5V22H2V17.5C2 15.567 3.567 14 5.5 14ZM18.5 14C20.433 14 22 15.567 22 17.5V22H20V17.5C20 16.7203 19.4051 16.0796 18.6445 16.0069L18.5 16C18.3248 16 18.1566 16.03 18.0003 16.0852L18 16C18 15.3343 17.8916 14.694 17.6915 14.0956C17.9499 14.0326 18.2211 14 18.5 14ZM5.5 8C6.88071 8 8 9.11929 8 10.5C8 11.8807 6.88071 13 5.5 13C4.11929 13 3 11.8807 3 10.5C3 9.11929 4.11929 8 5.5 8ZM18.5 8C19.8807 8 21 9.11929 21 10.5C21 11.8807 19.8807 13 18.5 13C17.1193 13 16 11.8807 16 10.5C16 9.11929 17.1193 8 18.5 8ZM5.5 10C5.22386 10 5 10.2239 5 10.5C5 10.7761 5.22386 11 5.5 11C5.77614 11 6 10.7761 6 10.5C6 10.2239 5.77614 10 5.5 10ZM18.5 10C18.2239 10 18 10.2239 18 10.5C18 10.7761 18.2239 11 18.5 11C18.7761 11 19 10.7761 19 10.5C19 10.2239 18.7761 10 18.5 10ZM12 2C14.2091 2 16 3.79086 16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2ZM12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4Z"></path></svg>				</span>
			</div>
               <div class="found-one__content">
                  <h4 class="found-one__title">Dedicated Team & Volunteers</h4>
                  <p class="found-one__text">Our passionate team and volunteers work selflessly with commitment to create positive social impact.</p>
               
                 
               </div>
            </div>
         </div>

           <div class=" col-lg-3 d-flex wow fadeInRight animated" data-wow-delay="300ms">
            <div class="why-item">
                <div class="elementor-icon-box-icon">
				<span class="elementor-icon">
				<svg xmlns="http://www.w3.org/2000/svg" height="512" viewBox="0 0 56 60" width="512"><g id="Page-1" fill-rule="evenodd"><g id="018---Embrace-Eco" fill-rule="nonzero" transform="translate(0 -1)"><path id="Shape" d="m3.5 18c-1.93299662 0-3.5 1.5670034-3.5 3.5v9.115c.00034493 1.0867893.2958642 2.1530782.855 3.085l8 13.337c.09318587.1556518.14259295.3335863.143.515v1.63c-1.1942507.4231743-1.99389286 1.5509979-1.998 2.818v6c0 1.6568542 1.34314575 3 3 3h13c1.6568542 0 3-1.3431458 3-3v-6c-.0052514-1.2667854-.8056491-2.3937454-2-2.816v-5.628c.0004298-1.2509234-.4680558-2.4565691-1.313-3.379l-8.048-8.777c-1.4265558-1.5481475-3.8058806-1.7335211-5.455-.425l-1.157.929-.576-.7c-.29382599-.3597356-.45328122-.8105237-.451-1.275v-8.429c0-1.9329966-1.56700338-3.5-3.5-3.5zm20.5 40c0 .5522847-.4477153 1-1 1h-13c-.55228475 0-1-.4477153-1-1v-6c0-.5522847.44771525-1 1-1h13c.5522847 0 1 .4477153 1 1zm-13.567-25.468c.8253643-.655452 2.0168489-.5620536 2.73.214l8.049 8.782c.5071792.5535809.7883535 1.2772121.788 2.028l.0000003 5.444h-11.0000003v-1.446c.0002504-.543992-.1477148-1.0777731-.428-1.544l-8-13.338c-.3738893-.6210165-.57162861-1.3321175-.572-2.057v-9.115c.00000002-.8284271.67157289-1.5 1.5-1.5s1.49999998.6715729 1.5 1.5v8.429c-.0002038.922706.31764786 1.8172819.9 2.533l1.2 1.462 7.124 8.706c.2241791.2828543.5833814.4229611.9398725.3665971.3564912-.0563639.6549494-.3004518.7809323-.6386694.1259829-.3382175.0599401-.7180787-.1728048-.9939277l-6.48-7.92z"></path><path id="Shape" d="m19 52c-1.6568542 0-3 1.3431458-3 3s1.3431458 3 3 3 3-1.3431458 3-3-1.3431458-3-3-3zm0 4c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1 1 .4477153 1 1-.4477153 1-1 1z"></path><path id="Shape" d="m47.143 47.04 8-13.337c.5600814-.9327139.8562935-2.0000451.857-3.088v-9.115c0-1.9329966-1.5670034-3.5-3.5-3.5s-3.5 1.5670034-3.5 3.5v8.429c-.0000857.461511-.1597779.9087905-.452 1.266l-.576.7-1.159-.931c-1.6480815-1.3077555-4.0260912-1.1219121-5.451.426l-8.049 8.784c-.8463193.9227744-1.3149623 2.1298957-1.313 3.382v5.628c-1.1943509.4222546-1.9947486 1.5492146-2 2.816v6c0 1.6568542 1.3431458 3 3 3h13c1.6568542 0 3-1.3431458 3-3v-6c-.0052514-1.2667854-.8056491-2.3937454-2-2.816v-1.63c.0002387-.181122.0496645-.3587785.143-.514zm-12.355-5.511 8.05-8.784c.7121902-.7744069 1.9012154-.8681854 2.726-.215l1.142.917-6.48 7.92c-.2327449.275849-.2987877.6557102-.1728048.9939277.1259829.3382176.4244411.5823055.7809323.6386694.3564911.056364.7156934-.0837428.9398725-.3665971l7.121-8.7v-.005l1.205-1.466c.5827143-.7155145.9006133-1.6102235.9-2.533v-8.429c0-.8284271.6715729-1.5 1.5-1.5s1.5.6715729 1.5 1.5v9.115c.0000116.7249789-.19701 1.4363306-.57 2.058l-8 13.338c-.2810923.465613-.4297682.9991174-.43 1.543v1.446h-11.0000021l.0000021-5.444c-.0008839-.750589.2803796-1.474093.788-2.027zm12.212 16.471c0 .5522847-.4477153 1-1 1h-13c-.5522847 0-1-.4477153-1-1v-6c0-.5522847.4477153-1 1-1h13c.5522847 0 1 .4477153 1 1z"></path><path id="Shape" d="m37 52c-1.6568542 0-3 1.3431458-3 3s1.3431458 3 3 3 3-1.3431458 3-3-1.3431458-3-3-3zm0 4c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1 1 .4477153 1 1-.4477153 1-1 1z"></path><path id="Shape" d="m29.951 1.723c-1.1196749-.96834414-2.7803251-.96834414-3.9 0-1.132.969-11.051 9.744-11.051 19.277 0 9.287 9.339 13.643 12 14.7v7.3c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-7.3c2.661-1.057 12-5.413 12-14.7 0-9.533-9.919-18.308-11.049-19.277zm-1.951 32.212c-1.836-.708-11-4.66-11-12.935 0-7.016 6.507-14.464 10.352-17.758.3726337-.32436508.9273663-.32436508 1.3 0 3.841 3.294 10.348 10.742 10.348 17.758 0 8.275-9.164 12.227-11 12.935z"></path><path id="Shape" d="m29 10c0-.55228475-.4477153-1-1-1s-1 .44771525-1 1v5.382l-4.553-2.277c-.3197527-.1596977-.7004141-.1366785-.9985927.0603866-.2981787.1970651-.4685741.5382372-.4470001.895.0215741.3567629.2318401.6749157.5515928.8346134l5.447 2.723v2.764l-4.553-2.277c-.3197527-.1596977-.7004141-.1366785-.9985927.0603866-.2981787.1970651-.4685741.5382372-.4470001.895.0215741.3567629.2318401.6749157.5515928.8346134l5.447 2.723v2.764l-4.553-2.277c-.3197527-.1596977-.7004141-.1366785-.9985927.0603866-.2981787.1970651-.4685741.5382372-.4470001.895.0215741.3567629.2318401.6749157.5515928.8346134l5.447 2.723v1.382c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1.382l5.447-2.718c.3197527-.1596977.5300187-.4778505.5515928-.8346134.0215741-.3567628-.1488214-.6979349-.447-.895-.2981787-.1970651-.6788401-.2200843-.9985928-.0603866l-4.553 2.272v-2.764l5.447-2.718c.3197527-.1596977.5300187-.4778505.5515928-.8346134.0215741-.3567628-.1488214-.6979349-.447-.895-.2981787-.1970651-.6788401-.2200843-.9985928-.0603866l-4.553 2.272v-2.764l5.447-2.718c.4942949-.2468713.6948713-.8477051.448-1.342s-.8477051-.6948713-1.342-.448l-4.553 2.272z"></path></g></g></svg>				</span>
			</div>
               <div class="found-one__content">
                  <h4 class="found-one__title">Sustainable Impact</h4>
                  <p class="found-one__text">We focus on long-term, meaningful solutions that create lasting change beyond temporary relief.</p>
               
                  
               </div>
            </div>
         </div>
              </div>
            </div>
         </div>
        
       
         
      </div>
     </div>
   </div>
</section>

            <div className="our-latest-area padding-bottom-90 padding-top-90">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-12">
                            <div className="help-and-support-left">
                                <div className="section-title margin-bottom-35">

                                    <h2 className="title">
                                        Save a life. Donate to  <span>MNB Foundation</span>
                                    </h2>
                                    <p>
                                        ‘MNB Foundation’ is a non-profit Charity Organization with more than 10 branches in India, MNB Foundation has transformed lives in every dimension spoken. From eliminating the root problems of education by providing free education and meals to providing special guided education to the deaf and dumb. From teaching life skills to the visually impaired to the professional skill development of the differently-abled.
                                    </p>
                                    <p>‘MNB Foundation’ was established in the year 2023 with a fistful of flour and to serve the patients belonging to the physically and economically disadvantaged sections of the society through the free-of-cost corrective surgeries of patients suffering from polio and other congenital disabilities. The headquarters of the organization is at Noida city in the state of Uttar Pradesh, India.</p>
                                </div>

                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-12">
                            <div className="help-and-support-right bg-image padding-top-50">
                                <div className="feature-box"><div className="feature-icon"><img src="https://quomodosoft.com/wp/profund/wp-content/uploads/2019/08/icon-1.png" className="attachment-full size-full" loading="lazy" width="48" height="48" /></div><div className="box-content"><h4 className="feature-title">Educations for Children</h4></div></div>

                                <div className="feature-box"><div className="feature-icon"><img src="https://quomodosoft.com/wp/profund/wp-content/uploads/2019/08/icon-2.png" className="attachment-full size-full" loading="lazy" width="42" height="47" /></div><div className="box-content"><h4 className="feature-title">Home for homeless people</h4></div></div>
                                <div className="feature-box"><div className="feature-icon"><img src="https://quomodosoft.com/wp/profund/wp-content/uploads/2019/08/icon-3.png" className="attachment-full size-full" loading="lazy" width="48" height="42" /></div><div className="box-content"><h4 className="feature-title">Food for hungry peoples</h4></div></div>
                                <div className="feature-box"><div className="feature-icon"><img src="https://quomodosoft.com/wp/profund/wp-content/uploads/2019/08/icon-4.png" className="attachment-full size-full" loading="lazy" width="48" height="48" /></div><div className="box-content"><h4 className="feature-title">Medicine for poor people</h4></div></div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="work-towards-area bg-image padding-bottom-115 padding-top-120" style={{ backgroundImage: "url(/main/files/static/works-towards.jpg)" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9 col-md-12">
                            <div className="left-content">
                                <div className="inner-section-title padding-top-160 bg-image" style={{ backgroundImage: "url(/main/files/static/charity.png)" }}>
                                    <h2 className="title">Works towards supporting underprivileged people</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="right-content">
                                <div className="vdo-btn">
                                    <Link className="video-play mfp-iframe" href="https://www.youtube.com/watch?v=-ZwQtICNbRc"><i className="fas fa-play"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="problem-area padding-top-90 padding-bottom-85">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-sm-11 col-11">
                            <div className="section-title b-top desktop-center padding-top-25 margin-bottom-55">
                                <span>What we do</span>
                                <h2 className="title">

                                    We have chosen the following issues.
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row d-flex">
                        <div className="col-lg-4 col-md-6">
                            <div className="problem-single-item margin-bottom-30">
                                <div className="icon">
                                    <MdHealthAndSafety />
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <Link href>{home?.what_we_do[0]?.title}</Link>
                                    </h4>
                                    <p><div className="Container" dangerouslySetInnerHTML={{ __html: home?.what_we_do[0]?.content }}></div><br /><br /><br />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="problem-single-item margin-bottom-30">
                                <div className="icon style-01">
                                    <FaGraduationCap />
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <Link href="">{home?.what_we_do[1]?.title}</Link>
                                    </h4>
                                    <p><div className="Container" dangerouslySetInnerHTML={{ __html: home?.what_we_do[1]?.content }}></div><br /> <br />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="problem-single-item margin-bottom-30">
                                <div className="icon style-02">
                                    <FaEnvira />
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <Link href="">{home?.what_we_do[2]?.title}</Link>
                                    </h4>
                                    <p><div className="Container" dangerouslySetInnerHTML={{ __html: home?.what_we_do[2]?.content }}></div></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="counterup-area bg-image padding-bottom-75 padding-top-90" style={{ backgroundImage: "url(/main/files/static/bg03.jpg)" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-counterup-01">
                                <div className="icon">
                                    <BsPiggyBank />
                                </div>
                                <div className="content">
                                    <div className="count-wrap"><span className="count-num">{home?.counter[0]?.count}</span>+</div>
                                    <h4 className="title">{home?.counter[0]?.title}</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-counterup-01">
                                <div className="icon">
                                    <AiOutlineUsergroupAdd />
                                </div>
                                <div className="content">
                                    <div className="count-wrap"><span className="count-num">{home?.counter[1]?.count}</span>+</div>
                                    <h4 className="title">{home?.counter[1]?.title}</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-counterup-01">
                                <div className="icon">
                                    <AiOutlineUserSwitch />
                                </div>
                                <div className="content">
                                    <div className="count-wrap"><span className="count-num">{home?.counter[2]?.count}</span>+</div>
                                    <h4 className="title">{home?.counter[2]?.title}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="testimonial-area padding-bottom-105 padding-top-115">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8 col-lg-12 p-0">
                            <div className="section-title desktop-center margin-bottom-50">
                                <span>Testimonial</span>
                                <h3 className="title">
                                    What <span>peoples</span> say about us
                                </h3>
                            </div>
                        </div>
                    </div>
                    <Carousel>
                        {
                            home.testimonial && home.testimonial.map((test) => {
                                return (
                                    <Carousel.Item>
                                        <div className="d-block w-100">
                                            <div className="thumb-prof text-center" >
                                                <img src={process.env.REACT_APP_IMG_BASE_URL + '/img/' + test.image} /></div>
                                            <h4 className="title text-center">{test.name}</h4>
                                            <p className="description text-center mb-5"><div className="Container" dangerouslySetInnerHTML={{ __html: test.content }}></div></p>
                                        </div>
                                    </Carousel.Item>
                                )
                            })
                        }
                    </Carousel>
                </div>
            </section>
        </section>
    </>)
}
export default Home;